import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";
import "./Program.css";

function ProgramEdit() {
    const navigate = useNavigate();
    const { id_program } = useParams();

    const [formValue, setFormValue] = useState({
        cover_foto: null,
        foto_slider: null,
        foto_slider2: null,
        foto_slider3: null,
        foto_slider4: null,
        foto_slider5: null,
        foto_slider6: null,
        title: "",
        penjelasan: "",
    });

    const [preview, setPreview] = useState({
        cover_foto: null,
        foto_slider: null,
        foto_slider2: null,
        foto_slider3: null,
        foto_slider4: null,
        foto_slider5: null,
        foto_slider6: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/program/readProgramById/${id_program}`
                );
                const data = response.data;
                setFormValue({
                    cover_foto: data.cover_foto,
                    foto_slider: data.foto_slider,
                    foto_slider2: data.foto_slider2,
                    foto_slider3: data.foto_slider3,
                    foto_slider4: data.foto_slider4,
                    foto_slider5: data.foto_slider5,
                    foto_slider6: data.foto_slider6,
                    title: data.title,
                    penjelasan: data.penjelasan,
                });
                setPreview({
                    cover_foto: data.cover_foto,
                    foto_slider: data.foto_slider,
                    foto_slider2: data.foto_slider2,
                    foto_slider3: data.foto_slider3,
                    foto_slider4: data.foto_slider4,
                    foto_slider5: data.foto_slider5,
                    foto_slider6: data.foto_slider6,
                });
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: "Gagal memuat data",
                    icon: "error",
                });
            }
        };

        fetchData();
    }, [id_program]);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setFormValue({
                ...formValue,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: event.target.value,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { title, penjelasan } = formValue;

        if (!title || !penjelasan) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        if (formValue.cover_foto) FormDataInput.append("cover_foto", formValue.cover_foto);
        if (formValue.foto_slider) FormDataInput.append("foto_slider", formValue.foto_slider);
        if (formValue.foto_slider2) FormDataInput.append("foto_slider2", formValue.foto_slider2);
        if (formValue.foto_slider3) FormDataInput.append("foto_slider3", formValue.foto_slider3);
        if (formValue.foto_slider4) FormDataInput.append("foto_slider4", formValue.foto_slider4);
        if (formValue.foto_slider5) FormDataInput.append("foto_slider5", formValue.foto_slider5);
        if (formValue.foto_slider6) FormDataInput.append("foto_slider6", formValue.foto_slider6);
        FormDataInput.append("title", title);
        FormDataInput.append("penjelasan", penjelasan);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = `Bearer ${token}`;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            await axios.put(
                `${process.env.REACT_APP_API_URL}/program/updateProgram/${id_program}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Sukses",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/program");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
            console.error("Gagal memperbarui data:", error);
        }
    };

    return (
        <div>
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Edit Program</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Administrasi</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Edit Program</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Program</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label>Judul</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="title"
                                                    value={formValue.title}
                                                    onChange={handleChange}
                                                    placeholder="Masukkan Judul"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Penjelasan</label>
                                                <textarea
                                                    className="form-control"
                                                    name="penjelasan"
                                                    value={formValue.penjelasan}
                                                    onChange={handleChange}
                                                    rows="3"
                                                    placeholder="Masukkan Penjelasan"
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <label>Cover Foto</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="cover_foto"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview.cover_foto && (
                                                    <div className="preview-container-program">
                                                        <img
                                                            src={preview.cover_foto}
                                                            alt="Preview"
                                                            className="preview-image-program"
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {[
                                                "foto_slider",
                                                "foto_slider2",
                                                "foto_slider3",
                                                "foto_slider4",
                                                "foto_slider5",
                                                "foto_slider6",
                                            ].map((fieldName, index) => (
                                                <div className="form-group" key={index}>
                                                    <label>{`Foto Slider ${index + 1}`}</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name={fieldName}
                                                        accept="image/*"
                                                        onChange={handleChange}
                                                    />
                                                    {preview[fieldName] && (
                                                        <div className="preview-container-program">
                                                            <img
                                                                src={preview[fieldName]}
                                                                alt="Preview"
                                                                className="preview-image-program"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-primary">
                                                    Update
                                                </button>
                                                <Link
                                                    to="/program"
                                                    className="btn btn-secondary ml-2"
                                                >
                                                    Kembali
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {cropData.isOpen && (
                <ImageCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={setCroppedImage}
                    onCropComplete={applyCrop}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default ProgramEdit;
